import styled from '@emotion/styled';
import { Text } from '@/components/atoms/Text';

export const IconContainer = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ theme }) => theme.font.size.medium};
    height: ${({ theme }) => theme.font.size.medium};
    border: 1px solid;
    border-radius: 50%;
    cursor: pointer;
`;

export const TooltipContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing[5]} ${({ theme }) => theme.spacing[3]};
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const StyledText = styled(Text)`
    color: ${({ theme }) => theme.color.white100};
    max-width: 200px;
`;
